import { createSlice } from "@reduxjs/toolkit"


export const SCHEDULE_FORM = 'schedule_form'
export const SCHEDULE_PAYLOAD = 'schedule_payload'

const initialState = {
    openModal: false,
    openDeleteModal: false,
    modalView: SCHEDULE_FORM,
    selectedScheduleId: null,
    viewMode: localStorage.getItem('scheduleViewMode') || 'cards',
}

const stateSlice = createSlice({
    name: "ticketSchedule/state",
    initialState,
    reducers: {
        setOpenModalTicketSchedule: (state, action) => {
            const { open, view } = action.payload
            state.openModal = open
            state.modalView = view ?? SCHEDULE_FORM
        },
        setOpenDeleteModal: (state, action) => {
            state.openDeleteModal = action.payload
        },
        setSelectedScheduleId: (state, action) => {
            state.selectedScheduleId = action.payload
        },
        setViewMode: (state, action) => {
            state.viewMode = action.payload
            localStorage.setItem('scheduleViewMode', action.payload)
        },
    }
})

export const {
    setOpenModalTicketSchedule,
    setOpenDeleteModal,
    setSelectedScheduleId,
    setViewMode,
} = stateSlice.actions

export default stateSlice.reducer
